module.exports = __webpack_public_path__ + "media/bootstrap-icons/clipboard-check-a4277d58.svg";